export default {"src":"/_next/static/image/src/assets/icons/filter-icons/wifi.416ed1b135c6f1d370e88ec7d6e391f5.svg","height":32,"width":32};